/** Die RKSV-Belegangaben aus dem QR-Payload: `_R1-AT<n>_<kassenId>_<belegNr>_<zeit>_…`.
 *
 *  Die Kassenidentifikationsnummer muss als LESBARER TEXT auf dem Beleg stehen
 *  (§ 132a BAO / RKSV-Belegangaben) — der QR allein genügt nicht (Hinweis
 *  fiskaltrust/W. Rüting, 19.08.2026). Ein Payload, der nicht nach `_R1-AT`
 *  aussieht, liefert null — dann druckt der Beleg nur den QR wie bisher.
 *
 *  Eigenes Mini-Modul, weil BEIDE Belegfassungen es brauchen (Belegblatt.tsx
 *  und belegPdf.ts) und belegPdf per Hausregel ausschließlich nachgeladen
 *  werden darf (S9-Wächter) — ein statischer Import von dort wäre der Fehler.
 */
export function rksvBelegangaben(qr: string): { kassenId: string; belegNr: string } | null {
  if (!qr.startsWith('_R1-AT')) return null
  const teile = qr.split('_')
  // teile[0] = '' (führender Unterstrich), [1] = 'R1-AT3', [2] = Kassen-ID, [3] = Belegnummer
  if (teile.length < 4 || !teile[2] || !teile[3]) return null
  return { kassenId: teile[2], belegNr: teile[3] }
}
